import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment/moment";

export var AnnouncementListRes;
export const AnnouncementListTodo = createAsyncThunk('AnnouncementList', async (date) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_announcement_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "current_date": date ? moment(date).format('DD/MM/YYYY') : '',
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return AnnouncementListRes = res.data
    } catch (error) {
        return AnnouncementListRes = error.response.data
    }
})


const AnnouncementListSlice = createSlice({
    name: 'AnnouncementList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(AnnouncementListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('AnnouncementList', state.data)
            }
        });
        builder.addCase(AnnouncementListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default AnnouncementListSlice.reducer; 